import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';
@Component({
  components: {},
  mixins: [style],
})
export default class Swiper extends Vue {
  @Prop({ default: () => {} })
    value: NewDisplayShopBg;

  render(h) {
    return <img src={`${this.value.desc[0].imageUrl}?imageView2/1/w/750/h/900`} alt="" class="width-100" />;
  }
}
